const firebaseConfig = {
    apiKey: "AIzaSyA0kXQTag5P0jaiMmU0aKg9a3N64R8V58U",
    authDomain: "archies-67c87.firebaseapp.com",
    projectId: "archies-67c87",
    storageBucket: "archies-67c87.appspot.com",
    messagingSenderId: "642540289468",
    appId: "1:642540289468:web:c4d47b78fd01a58d62ffb9"
  };

  export default firebaseConfig;